export const fields = [
  {
    label: 'Family/ Last name',
    name: 'lastName',
    type: 'text',
  },
  {
    label: 'Given name(s)',
    name: 'firstName',
    type: 'text',
  },
  {
    label: 'Date of birth',
    name: 'dateOfBirth',
    type: 'date',
  },
  {
    label: 'Patient identifiers',
    name: 'patientId',
    type: 'text',
  },
  {
    label: 'Date of request',
    name: 'dateOfRequest',
    type: 'date',
  },
  {
    label: 'Accession/Laboratory number',
    name: 'laboratoryNumber',
    type: 'text',
  },
];
